<template>
  <v-card>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title>{{ title }}</v-list-item-title>
        <v-list-item-subtitle class="mt-3">{{ summary.text }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-list-item-action-text>{{ moment(created_at) }}</v-list-item-action-text>
        <div>&nbsp;</div>
      </v-list-item-action>
    </v-list-item>
    <v-card-text class="py-0" v-if="actions.length > 0">
      <template v-for="(action,i) in actions">
        <contact-form
          v-if="category == 'messaging.user' && i == 1"
          :username="summary.links.username"
          :to="summary.links.user_uuid"
        >
          <template v-slot:default="{on}">
            <a href="#" class="font-weight-light mr-3" v-on="on">{{ action.text }} ...</a>
          </template>
        </contact-form>

        <a
          href="#"
          v-else
          class="font-weight-light mr-3"
          v-bind="action.props"
          @click.prevent="action.click"
        >{{ action.text }}</a>
      </template>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn
        color="primary"
        v-if="!read_at"
        :loading="saving == uuid"
        text
        @click="read"
      >{{ trans('notification.action_read') }}</v-btn>
      <v-btn
        color="secondary"
        v-if="read_at"
        :loading="saving == uuid"
        text
        @click="unread"
      >{{ trans('notification.action_unread') }}</v-btn>

      <v-btn
        color="danger"
        :loading="deleting == uuid"
        text
        @click="deleteItem"
      >{{ trans('notification.action_delete') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import api from "../api";
import ContactForm from "./ContactForm";

export default {
  props: [
    "bookmarked",
    "category",
    "created_at",
    "deleted_at",
    "read_at",
    "summary",
    "links",
    "advert",
    "user_uuid",
    "username",
    "meta",
    "text",
    "title",
    "updated_at",
    "uuid",
    //
    "saving",
    "deleting"
  ],

  components: {
    ContactForm
  },

  computed: {
    actions: function() {
      let actions = [];

      if (this.$props.category == "messaging.user") {
        actions.push({
          text: this.trans("message.blacklist_user", null, "Add to blacklist"),
          click: () => this.blacklistUser(),
          props: null
        });
        actions.push({
          text: this.trans("message.reply_to_user", null, "Reply to user"),
          click: () => this.replyUser(),
          props: null
        });
      }

      if (
        this.$props.category == "adver.interesting" ||
        this.$props.category == "advert.interesting"
      ) {
        actions.push({
          text: this.trans(
            "notification.link_property",
            null,
            "View the property"
          ),
          click: () =>
            this.$router.push({
              name: "advert-details",
              params: { uuid: this.summary.links.advert }
            }),
          props: null
        });
      }

      if (
        this.$props.category == "preferences.subscription" ||
        this.$props.category == "saved_search.subscription"
      ) {
        actions.push({
          text: this.trans(
            "notification.link_properties",
            null,
            "View properties"
          ),
          click: () =>
            this.$router.push({
              name: "subscriptions"
            }),
          props: null
        });
      }

      if (this.$props.category == "messaging.admin") {
      }

      return actions;
    }
  },

  data: () => ({
    loading: false,
    chat_active: false
  }),

  methods: {
    read: function() {
      this.$emit("read", this.$props.uuid);
    },
    unread: function() {
      this.$emit("unread", this.$props.uuid);
    },
    deleteItem: function() {
      this.$emit("delete", this.$props.uuid);
    },

    // ...
    blacklistUser: function() {
      let sender_uuid = this.summary.links.user_uuid;
      this.loading = true;
      api.message
        .blacklist(sender_uuid)
        .then(response => {
          this.read();
        })
        .catch(error => {})
        .then(() => {
          this.loading = false;
        });
      // whitelist
      // this.read();
    },

    replyUser: function() {
      this.chat_active = true;
    }
  }
};
</script>